<template>
  <div
    class="title-container"
    :class="{
      'highlight': highlight,
    }"
  >
    <div
      class="title"

    >
      <slot></slot>
    </div>

    <slot
      class="actions"
      name="action"
    ></slot>
  </div>
</template>

<script>
export default {
  name: 'SectionTitle',

  props: {
    highlight: {
      type: Boolean,
      default: false,
    },

    flat: {
      type: Boolean,
      default: false,
    }
  }
}
</script>

<style scoped>
.title-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  line-height: 20px;
  padding: 10px;
  border-bottom: 1px solid #cacaca;
  box-shadow: 0 3px 5px #d8d8d8;
  border-top: 1px solid #d8d8d8;
  background: #00b5c42b;
}

.title {

}

.highlight {
  background: #154fb7;
  color: white;
  font-weight: 600;
  animation: slide-in 0.5s forwards;
  transform: translateX(-100%);
}

@keyframes slide-in {
  100% { transform: translateX(0%); }
}

.actions {

}
</style>
